import React, { useEffect, useRef } from "react";
import "./Certificate.css";

/* Swiper */
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

/* Img */
const proyectImg = require.context("../../assets", true);
const data = [
  proyectImg(`./Communication Foundations.jfif`),
  proyectImg(`./rabbitMQ.jfif`),
  proyectImg("./restWithNodeAndExpress.jpg"),
  proyectImg("./Angular Basic HackerRank.png"),
  proyectImg("./Angular Building Large Applications.jpeg"),
  proyectImg("./wordpress.jpg"),
  proyectImg("./js.jpg"),
  proyectImg("./css.jpg"),
  proyectImg("./react.jpg"),
  proyectImg("./node.jpg"),
  proyectImg("./apiWithASP.NET.jpg"),
  proyectImg("./db.jpg"),
  proyectImg(`./Dart.jpg`),
  proyectImg(`./flutter.jpg`),
  proyectImg(`./digital skills.jpg`),
  proyectImg(`./JCPC.jpg`),
];

const AOS_DURATION_MS = 2000;

const Certificate = () => {
  const sectionRef = useRef(null);
  const swiperRef = useRef(null);
  const autoplayStarted = useRef(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    let startTimer;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const swiper = swiperRef.current;
        if (!swiper?.autoplay) return;

        if (entry.isIntersecting) {
          if (autoplayStarted.current) {
            swiper.autoplay.start();
            return;
          }

          // Wait for the flip-in animation, then start from the first slide
          startTimer = window.setTimeout(() => {
            swiper.slideToLoop(0, 0);
            swiper.autoplay.start();
            autoplayStarted.current = true;
          }, AOS_DURATION_MS);
        } else {
          window.clearTimeout(startTimer);
          swiper.autoplay.stop();
        }
      },
      { threshold: 0.35 },
    );

    observer.observe(section);
    return () => {
      window.clearTimeout(startTimer);
      observer.disconnect();
    };
  }, []);

  return (
    <section className="proyectos" id="certificates" ref={sectionRef}>
      <h2 className="heading">Certificates</h2>
      <div
        className="proyect-site"
        data-aos="flip-left"
        data-aos-easing="ease-out-cubic"
        data-aos-duration={AOS_DURATION_MS}
      >
        <Swiper
          spaceBetween={30}
          loop={true}
          grabCursor={true}
          centeredSlides={true}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination, Autoplay]}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
            swiper.autoplay.stop();
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="proyectos-slider mySwiper"
        >
          {data.map((src) => (
            <SwiperSlide className="caja" key={src}>
              <img src={src} alt="proyectos" />
              <div className="content">{/* <h3>Justice</h3> */}</div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-pagination"></div>
      </div>
    </section>
  );
};

export default React.memo(Certificate);
